import { render, staticRenderFns } from "./new.vue?vue&type=template&id=3ad1765b&scoped=true&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./new.vue?vue&type=style&index=1&id=3ad1765b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad1765b",
  null
  
)

export default component.exports